export const CALENDLY_URL =
  'https://calendly.com/d/zk5-xbh-nwq/surglogs-demonstration'

export const CALENDLY_URL_FILLABLE_DOCUMENTS_PROMO =
  'https://calendly.com/nikol-petkova/surglogs-feedback-30-min'
